import cn from '../lib/cn';
import wordmarkSrc from '../assets/jobcard-wordmark.png';

/**
 * The JobCard wordmark.
 *
 * The artwork (`JobCard/client/public/logo.png`, trimmed to its ink bounds) is
 * a white silhouette on transparent — which would be invisible against the
 * light appearance's near-white canvas if it were rendered as an image.
 *
 * So it is not rendered as an image. It is used as a CSS mask over a coloured
 * box, which means the glyphs take `--label` and follow the appearance: near
 * black on light, white on dark, with no second asset and no filter hack. It
 * also drops the faint blue anti-alias fringe in the source, so the edges take
 * the fill cleanly rather than haloing.
 *
 * Height-driven rather than width-driven: it sits next to text, and matching a
 * cap height is what makes a lockup look deliberate.
 */

// From the trimmed asset: 807 × 303.
const RATIO = 807 / 303;

export default function Wordmark({ height = 28, className, title = 'JobCard' }) {
  return (
    <span
      role="img"
      aria-label={title}
      className={cn('block shrink-0 bg-label', className)}
      style={{
        height,
        width: Math.round(height * RATIO),
        maskImage: `url(${wordmarkSrc})`,
        WebkitMaskImage: `url(${wordmarkSrc})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
      }}
    />
  );
}
